import { useJsApiLoader } from '@react-google-maps/api';

const LIBRARIES = ['places'];

export function useGoogleMaps(apiKey) {
    return useJsApiLoader({
        id: 'script-loader',
        googleMapsApiKey: apiKey,
        libraries: LIBRARIES,
        language: 'it',
        region: 'IT',
    });
}

function LoadedGoogleMaps({ apiKey, children, fallback, errorFallback }) {
    const { isLoaded, loadError } = useGoogleMaps(apiKey);
    return loadError ? errorFallback : isLoaded ? children : fallback;
}

export default function GoogleMapsLoader({ children, fallback = null, errorFallback = fallback }) {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim();
    return apiKey ? <LoadedGoogleMaps apiKey={apiKey} fallback={fallback} errorFallback={errorFallback}>{children}</LoadedGoogleMaps> : errorFallback;
}
